/*
 * @Description: 在空间X轴上的边
 * @Author: Xiaohua Zhu
 * @Date: 2021-12-02 19:15:44
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-06-22 09:25:50
 */
import { Vector3 } from '@babylonjs/core/Maths/math';
import { BASICTYPE_ENUM, SidePlatePosition, SidePlateSequence, SidePlateLocation, LengthType, SIDE_PLATE_TYPE, } from '../utils/enum';
import BaseLength from './baseLength';
import MeshManage from '../meshManage';
import { DEFAULTSEALPLATEDEPTH, GAP_BETWEEN_WALL_AND_CABINET, TOPFRAME_GROUND, SKIRTINGBOARDCONFIG, FRAMEDEPTH, FRAMECATEGORY, VERSION_2_2, DOUBLE_DOOR_REFIRGERATOR_DISTANCE, SINGLE_DOOR_REFIRGERATOR_DISTANCE, DEFAULTSEALPLATEWIDTH, DEFAULTTOPSEALPLATEWIDTH, CALLOUTMARGIN, } from '../utils/kitchenConfig';
import Wall from '../room/wall';
import WindowNode from '../room/window';
import { getFramePositionInfo, isHighCabinet } from '../utils/templatejsonUtils';
import { getCornerCabinetFrameXZ, checkFrameIsHighFrame, checkFrameIsCornerFrames, getDefaultDoor, } from '../utils/renderUtils';
import RenderVersion from '../utils/renderVersion';
import { getNewSinkHoleInfo, getOldXSinkHoleInfo } from '../utils/renderSinkUtils';
class LengthX extends BaseLength {
    /**
     *
     * @param templateJson
     * @param type top bottom
     * @description 判断是否只有高柜
     * @author: Kun Yang
     * @returns true false
     */
    static checkTopNoFrames(templateJson, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const frameLength = (_c = (_b = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.length1) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length;
        if (frameLength <= 2) {
            if (frameLength === 1) {
                const frame = (_e = (_d = templateJson[type]) === null || _d === void 0 ? void 0 : _d.length1) === null || _e === void 0 ? void 0 : _e.frames[frameLength - 1];
                if (checkFrameIsHighFrame(frame)) {
                    return true;
                }
            }
            if (frameLength === 2) {
                const lasetframe = (_g = (_f = templateJson[type]) === null || _f === void 0 ? void 0 : _f.length1) === null || _g === void 0 ? void 0 : _g.frames[frameLength - 1];
                const firtframe = (_j = (_h = templateJson[type]) === null || _h === void 0 ? void 0 : _h.length1) === null || _j === void 0 ? void 0 : _j.frames[frameLength - 2];
                if (checkFrameIsHighFrame(firtframe) && checkFrameIsHighFrame(lasetframe)) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }
    /**
       * @description: 渲染侧板
       * @param {*} frameJson 基准模型frame
       * @param {*} sequence 侧板放置的位置（前/后）
       * @return {*} { id:该侧板的id, rotation:该侧板所旋转的角度 }
       * @author: Xiaohua Zhu
       */
    // 通过传入frame来确定侧板需要摆放的基准点再向左移动位置
    renderSidePlate(frameJson, sidePlatesArr, sequence, position) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.sidePlatesArray = sidePlatesArr;
        this.initSidePlatesAndFrames(frameJson, sequence);
        const { sidePlateMeshSize, frameMeshSize, frameCenterPoint, sidePlate, sidePlateID, } = this;
        const { x: sidePlateSizeX, z: sidePlateSizeZ, y: sidePlateSizeY } = sidePlateMeshSize;
        const { x: frameSizeX, z: frameSizeZ, y: frameSizeY } = frameMeshSize;
        const { x: centerPointX, y: centerPointY, z: centerPointZ } = frameCenterPoint;
        const rotation = { x: 0, y: 0, z: 0 };
        const sidePlateScaling = frameSizeZ / sidePlateSizeX;
        if (sequence === SidePlateSequence.First && sidePlate) {
            const targetPosition = {
                x: centerPointX + frameSizeX / 2 + (sidePlateSizeZ * sidePlateScaling) / 2,
                y: centerPointY,
                z: centerPointZ,
            };
            // 二字型特殊处理 顶柜只有高柜 底柜只有20宽的柜体
            if (LengthX.checkTopNoFrames(this.templateJson, BASICTYPE_ENUM.top)) {
                targetPosition.x = 0;
                if (position === SidePlatePosition.Top) {
                    sidePlate.meshManage.mesh.scaling.y = (this.templateJson.top.height * 0.01) / sidePlateSizeY;
                    targetPosition.y = centerPointY + frameSizeY - (this.templateJson.top.height * 0.01);
                }
                else {
                    sidePlate.meshManage.mesh.scaling.y = (this.templateJson.bottom.height * 0.01) / sidePlateSizeY;
                }
            }
            rotation.y = Math.PI / 2;
            sidePlate.meshManage.mesh.scaling.x = sidePlateScaling;
            sidePlate.moveToPosition(targetPosition, rotation);
        }
        if (sequence === SidePlateSequence.Last && sidePlate) {
            let sealPlateLength = 0;
            if (((_b = (_a = this.templateJson[position]) === null || _a === void 0 ? void 0 : _a.length1) === null || _b === void 0 ? void 0 : _b.sealPlate)
                && this.getSealPlatePos(this.templateJson, position)
                    >= this.templateJson[position].length1.frames.length) {
                sealPlateLength = new MeshManage(this.scene
                    .getMeshByName((_d = (_c = this.templateJson[position]) === null || _c === void 0 ? void 0 : _c.length1) === null || _d === void 0 ? void 0 : _d.sealPlate[0].id)).getModelSize().x;
            }
            const targetPosition = {
                x: centerPointX - frameSizeX / 2 - (sidePlateSizeZ * sidePlateScaling) / 2 - sealPlateLength,
                y: centerPointY,
                z: centerPointZ,
            };
            // 二字型特殊处理 顶柜只有高柜 底柜只有20宽的柜体
            if (LengthX.checkTopNoFrames(this.templateJson, BASICTYPE_ENUM.top)) {
                targetPosition.x = centerPointX - frameSizeX / 2 - (sidePlateSizeZ * sidePlateScaling) / 2;
            }
            rotation.y = Math.PI / 2;
            sidePlate.meshManage.mesh.scaling.x = sidePlateScaling;
            sidePlate.moveToPosition(targetPosition, rotation);
        }
        if (sequence === SidePlateSequence.Corner && sidePlate) {
            let sidePlateXAfterScaling = 0;
            let sealPlateLength = 0;
            // 转交柜的情况比较特殊 侧板长度为常量 要按顶柜底柜区分
            if (position === SidePlatePosition.Top) {
                sidePlate.meshManage.mesh.scaling.x = FRAMEDEPTH.TOP / sidePlateSizeX;
                sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.TOP / sidePlateSizeX);
            }
            if (position === SidePlatePosition.Bottom) {
                sidePlate.meshManage.mesh.scaling.x = FRAMEDEPTH.BOTTOM / sidePlateSizeX;
                sidePlateXAfterScaling = sidePlateSizeX * (FRAMEDEPTH.BOTTOM / sidePlateSizeX);
            }
            // L1侧板贴在转角柜上 如果有补板 需要加上补板的宽度
            if (((_g = (_f = (_e = this.templateJson[position]) === null || _e === void 0 ? void 0 : _e.length1) === null || _f === void 0 ? void 0 : _f.sealPlate) === null || _g === void 0 ? void 0 : _g.length) > 0) {
                sealPlateLength = new MeshManage(this.scene
                    .getMeshByName((_j = (_h = this.templateJson[position]) === null || _h === void 0 ? void 0 : _h.length1) === null || _j === void 0 ? void 0 : _j.sealPlate[0].id)).getModelSize().x;
            }
            const targetPosition = {
                x: centerPointX - frameSizeX / 2 - sidePlateSizeZ / 2 - sealPlateLength,
                y: centerPointY,
                z: centerPointZ - (frameSizeZ - sidePlateXAfterScaling) / 2,
            };
            // 要获取到缩放后的侧板尺寸
            rotation.y = Math.PI / 2;
            sidePlate.moveToPosition(targetPosition, rotation);
        }
        return { id: sidePlateID, rotation };
    }
    // 获取lengthX上 最后一个柜体后的的补板长度（补板移动需要加上这个长度）
    getSealPlatesLength(position) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let sealPlateLength = 0;
        if (((_b = (_a = this.templateJson[position]) === null || _a === void 0 ? void 0 : _a.length1) === null || _b === void 0 ? void 0 : _b.sealPlate)
            && this.getSealPlatePos(this.templateJson, position)
                >= this.templateJson[position].length1.frames.length) {
            sealPlateLength = new MeshManage(this.scene
                .getMeshByName((_d = (_c = this.templateJson[position]) === null || _c === void 0 ? void 0 : _c.length1) === null || _d === void 0 ? void 0 : _d.sealPlate[0].id)).getModelSize().x;
        }
        if (this.templateJson.bottom.type === 'H'
            && position === SidePlatePosition.Top && ((_f = (_e = this.templateJson[position]) === null || _e === void 0 ? void 0 : _e.length1) === null || _f === void 0 ? void 0 : _f.frames.length) === 1
            && isHighCabinet((_h = (_g = this.templateJson[position]) === null || _g === void 0 ? void 0 : _g.length1) === null || _h === void 0 ? void 0 : _h.frames[0].categoryId)) {
            return 0;
        }
        return sealPlateLength;
    }
    renderSidePlateByLength(sidePlatesArr, position) {
        // 遍历侧板数组中的每一块侧板
        sidePlatesArr.forEach((sidePlateObj) => {
            if (sidePlateObj === null || sidePlateObj === void 0 ? void 0 : sidePlateObj.frameUUId) {
                /* -----------公共业务逻辑----------- */
                // 处理公共的业务 返回各自的业务所需要的 基准模型尺寸 侧板对象
                const { frameMeshSize: { x: frameSizeX, z: frameSizeZ }, sidePlate, } = this.initSidePlateConfig(sidePlateObj);
                /* -----------公共业务逻辑----------- */
                /* -----------私有数据处理----------- */
                // 侧板模型尺寸
                const { x: sidePlateSizeX, z: sidePlateSizeZ } = sidePlate.meshManage.size;
                // 侧板偏移量 基准模型长度的一半 + 侧板厚度的一半
                const basicDeviation = frameSizeX / 2 + (sidePlateSizeZ / 2);
                // 获取该length的 补板长度   冰箱顶柜侧板不需要加上补板的长度
                const sealPlateLength = sidePlateObj.type === SIDE_PLATE_TYPE.refrigerator
                    ? 0 : this.getSealPlatesLength(position);
                /* -----------私有数据处理----------- */
                /* -----------私有业务逻辑----------- */
                // 侧板尺寸缩放至 需要贴的基准模型的面 的尺寸
                sidePlate.meshManage.mesh.scaling.x = frameSizeZ / sidePlateSizeX;
                /* -----------私有业务逻辑----------- */
                /* -----------侧板分情况的业务逻辑----------- */
                // 根据侧板的location判断 偏移量的正负
                switch (sidePlateObj.location) {
                    // First为靠近坐标轴中心点的位置
                    case SidePlateLocation.First:
                        sidePlate.lengthXSidePlateAction(basicDeviation);
                        break;
                    // Last为远离坐标轴中心点的位置
                    case SidePlateLocation.Last:
                        sidePlate.lengthXSidePlateAction(-(basicDeviation + sealPlateLength));
                        // 侧板的type为1的时候是冰箱顶柜的侧板 不能用来计算冰箱的位置
                        if (sidePlateObj.type !== SIDE_PLATE_TYPE.refrigerator) {
                            this.sidePlatePositions[position].position = sidePlate.sidePosition;
                            this.sidePlatePositions[position].sideplateMesh = sidePlate;
                        }
                        else {
                            // 如果是冰箱顶柜的侧板的话 摆好位置之后将其group到cabinet上面 后面调整位置的时候一并调整
                            new MeshManage(this.scene.getMeshByName(sidePlateObj.frameUUId)).addChildModel(sidePlate.meshManage);
                        }
                        break;
                    // Corner为该侧板贴在转角柜的特殊情况
                    case SidePlateLocation.Corner:
                        sidePlate.cornerSidePlateAction(basicDeviation + sealPlateLength, position, LengthType.Length1);
                        this.sidePlatePositions[position].position = sidePlate.sidePosition;
                        this.sidePlatePositions[position].sideplateMesh = sidePlate;
                        break;
                    default:
                        break;
                }
                /* -----------侧板分情况的业务逻辑----------- */
            }
        });
    }
    /**
     * @description 获取补板位置
     * @param templateJson templateJSon
     * @param type 顶柜或者地柜
     * @returns null：没有 其他：哪一个柜体前面
     * @author: Kun Yang
     */
    // eslint-disable-next-line class-methods-use-this
    getSealPlatePos(templateJson, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const frameLenghth = (_c = (_b = (_a = templateJson[type]) === null || _a === void 0 ? void 0 : _a.length1) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c.length;
        const otherLength = (_e = (_d = templateJson[type]) === null || _d === void 0 ? void 0 : _d.length1) === null || _e === void 0 ? void 0 : _e.otherSealPlateLength;
        const lastFrame = frameLenghth ? (_g = (_f = templateJson[type]) === null || _f === void 0 ? void 0 : _f.length1) === null || _g === void 0 ? void 0 : _g.frames[frameLenghth - 1]
            : (_j = (_h = templateJson[type]) === null || _h === void 0 ? void 0 : _h.length1) === null || _j === void 0 ? void 0 : _j.frames[0];
        const lastPreFrame = frameLenghth >= 3 ? (_l = (_k = templateJson[type]) === null || _k === void 0 ? void 0 : _k.length1) === null || _l === void 0 ? void 0 : _l.frames[frameLenghth - 2]
            : null;
        // 没有柜体
        if (!frameLenghth) {
            return null;
        }
        // 有柜体 并且 有otherSealPlateLength ， 补板只会在最后一个普通柜前面
        if (frameLenghth && otherLength) {
            // 最后一个是高柜，返回倒数第二
            if (checkFrameIsHighFrame(lastFrame)) {
                // 是否是双高柜
                if (lastPreFrame && checkFrameIsHighFrame(lastPreFrame)) {
                    return frameLenghth - 2;
                }
                return frameLenghth - 1;
            }
            // 没有高柜，但是有otherLength，补板只会在最后一个普通柜前面
            if (frameLenghth > 1) {
                return frameLenghth;
            }
            // 最后不是高柜，返回第一个（加冰箱可能也会有otherLength）
            return 1;
        }
        // 默认返回第一个
        return 1;
    }
    /**
     *
     * @param {*} lengthSideType lenght1|lenght2|lenght3 哪条边
     * @description 1. 默认判断类型是否为高低柜 并返回位置
     * @returns isHighLowCabinet 边是否存在高低柜情况
     * @returns borderPososition 高低分界处frame的位置
     */
    getHightLowSinkCabinetPos(lengthSideType) {
        var _a, _b, _c, _d, _e, _f, _g;
        const lengthType = lengthSideType || LengthType.Length1;
        const lodaFrames = [
            ...((_b = (_a = this.templateJson) === null || _a === void 0 ? void 0 : _a.bottom) === null || _b === void 0 ? void 0 : _b[lengthType])
                ? [...(_e = (_d = (_c = this.templateJson) === null || _c === void 0 ? void 0 : _c.bottom) === null || _d === void 0 ? void 0 : _d[lengthType]) === null || _e === void 0 ? void 0 : _e.frames]
                : [],
        ];
        const firstFrameHight = (_g = (_f = lodaFrames[0]) === null || _f === void 0 ? void 0 : _f.componentBasic) === null || _g === void 0 ? void 0 : _g.height;
        if ((lodaFrames === null || lodaFrames === void 0 ? void 0 : lodaFrames.length) === 1) {
            return {
                isHighLowCabinet: false,
                borderPososition: 0,
            };
        }
        const isPos = lodaFrames.findIndex((frame) => {
            var _a;
            return ((((_a = frame === null || frame === void 0 ? void 0 : frame.componentBasic) === null || _a === void 0 ? void 0 : _a.height) !== firstFrameHight) // 不同高度
                && !checkFrameIsHighFrame(frame) // 只有高柜判断
                && checkFrameIsCornerFrames(frame, FRAMECATEGORY.CATEGORY_1) // L195-168型lengthz无缝隙，U型177-177-238无缝隙
            );
        });
        return {
            isHighLowCabinet: isPos > -1,
            borderPososition: isPos > -1 ? isPos : 0,
        };
    }
    /**
     *
     * @param frame 补板前一个柜体
     * @param lengthType top | bottom
     * @description 计算高低水槽影响的补板缩放尺寸
     * @returns 补板缩放的模型尺寸
     */
    zoomSealPlateY(frame, lengthType) {
        var _a, _b;
        const { componentBasic: { id } } = frame;
        let defaluFrameData = new MeshManage(this.scene.getMeshByName(id));
        // 补板位置
        const sealPlatePos = this.getSealPlatePos(this.templateJson, lengthType);
        // 不是1的位置，直接返回尺寸，不进行下面计算
        if (sealPlatePos !== 1) {
            return defaluFrameData.getModelSize().y;
        }
        // 是否是高低柜类型
        const { isHighLowCabinet, borderPososition } = this.getHightLowSinkCabinetPos(LengthType.Length1);
        // 处理转角柜情况 只有高低交界处为1的情况
        const getScaleYFrame = isHighLowCabinet && borderPososition === 1
            ? (_b = (_a = this.templateJson[lengthType]) === null || _a === void 0 ? void 0 : _a.length1) === null || _b === void 0 ? void 0 : _b.frames[borderPososition] : frame;
        defaluFrameData = new MeshManage(this.scene.getMeshByName(getScaleYFrame === null || getScaleYFrame === void 0 ? void 0 : getScaleYFrame.componentBasic.id));
        return defaluFrameData.getModelSize().y;
    }
    /**
     *
     * @param sealPlateData 补板数据
     * @param preMeshManage 补板在哪一个柜体前面 meshMange
     * @param type 顶柜/地柜
     * @param frameData 补板在哪一个柜体后面 柜体数据
     * @param _this this：添加到模型管理器使用
     * @returns 地柜：补板的meshMange 顶柜：正前方的meshManage
     */
    renderSealPlate(sealPlateData, preMeshManage, type, frameData, _this) {
        var _a, _b, _c;
        if (!sealPlateData.length) {
            return null;
        }
        let sealPlateMesh;
        const { componentBasic: { width, depth, id }, longEdge } = frameData;
        let longLength = longEdge === 2 ? width : depth;
        let scaleX = 0;
        let scaleY = 0;
        let scaleZ = 0;
        let moveZ = 0;
        let nextMeshManage = null;
        // 获取柜体门板的厚度
        const defalutDoor = getDefaultDoor(this.templateJson, 'length1', type);
        const defalutDoorMesh = new MeshManage(this.scene.getMeshByName((_a = defalutDoor === null || defalutDoor === void 0 ? void 0 : defalutDoor.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
        const drawerDoorDeepSize = ((_b = defalutDoorMesh === null || defalutDoorMesh === void 0 ? void 0 : defalutDoorMesh.getModelSize()) === null || _b === void 0 ? void 0 : _b.z) || DEFAULTSEALPLATEDEPTH;
        const defaluFrameData = new MeshManage(this.scene.getMeshByName(id));
        // 添加到模型管理器，清楚模型时使用
        this.initSealPlate(sealPlateData, _this);
        switch (type) {
            case BASICTYPE_ENUM.top:
                this.sealPlateData = sealPlateData; // 记录补板数据
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                sealPlateData.forEach((plate, plateInx) => {
                    var _a, _b, _c;
                    sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                    if (!(sealPlateMesh === null || sealPlateMesh === void 0 ? void 0 : sealPlateMesh.mesh)) {
                        sealPlateMesh = preMeshManage;
                        return;
                    }
                    switch (plateInx) {
                        case 0:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_a = this.sealPlate) === null || _a === void 0 ? void 0 : _a.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 设置旋转角度
                            this.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            longLength = depth;
                            moveZ = ((preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5)
                                / (longLength / 10)) * DEFAULTTOPSEALPLATEWIDTH;
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(this.templateJson) - sealPlateMesh.getModelSize().y * 0.5,
                                z: moveZ - sealPlateMesh.getModelSize().z,
                                // - sealPlateMesh.getModelSize().y,
                                // z: moveZ - preMeshManage.getModelSize().z,
                            });
                            break;
                        case 1:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = defaluFrameData.getModelSize().y / sealPlateMesh.getModelSize().y;
                            scaleZ = DEFAULTSEALPLATEDEPTH / sealPlateMesh.getModelSize().z;
                            (_b = this.sealPlate) === null || _b === void 0 ? void 0 : _b.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            longLength = depth;
                            moveZ = ((preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5)
                                / (longLength / 10)) * DEFAULTTOPSEALPLATEWIDTH;
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(this.templateJson) - preMeshManage.getModelSize().y,
                                z: moveZ + sealPlateMesh.getModelSize().z * 0.5,
                            });
                            // 顶柜的补板，需要返回正面的mesh 补板后面柜体需要移动
                            nextMeshManage = sealPlateMesh;
                            break;
                        case 2:
                            // 缩放
                            scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x;
                            scaleY = FRAMEDEPTH.TOP / sealPlateMesh.getModelSize().y;
                            (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY);
                            // 缩放后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            // 旋转
                            this.setMeshRotate(new Vector3(Math.PI / 2, 0, 0), sealPlateMesh);
                            // 旋转后需要重新获取尺寸信息
                            sealPlateMesh = new MeshManage(this.scene.getMeshByName(plate.id));
                            longLength = depth;
                            moveZ = ((preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5)
                                / (longLength / 10)) * DEFAULTTOPSEALPLATEWIDTH;
                            sealPlateMesh.setModelPosition({
                                x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                                    - sealPlateMesh.getModelSize().x * 0.5,
                                y: TOPFRAME_GROUND(this.templateJson) - preMeshManage.getModelSize().y
                                    + sealPlateMesh.getModelSize().y * 0.5,
                                z: moveZ - sealPlateMesh.getModelSize().z,
                            });
                            break;
                        default:
                            break;
                    }
                });
                return nextMeshManage;
                break;
            case BASICTYPE_ENUM.bottom:
                this.sealPlateData = sealPlateData; // 记录补板数据
                // 相同补板，默认取第一块数据保存实例
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                // DONE 高度的缩放 缩放
                scaleX = (sealPlateData[0].width / 100) / sealPlateMesh.getModelSize().x; // 以米为单位
                scaleY = this.zoomSealPlateY(frameData, type) / sealPlateMesh.getModelSize().y; // 补板前一个柜体的高度
                scaleZ = drawerDoorDeepSize / sealPlateMesh.getModelSize().z; // 门板厚度
                (_c = this.sealPlate) === null || _c === void 0 ? void 0 : _c.setSealPlatesScale(sealPlateMesh, scaleX, scaleY, scaleZ);
                // 缩放后需要重新获取尺寸信息
                sealPlateMesh = new MeshManage(this.scene.getMeshByName(sealPlateData[0].id));
                // 转角柜中心会偏移，需要动态计算
                // eslint-disable-next-line no-case-declarations
                let lastMoveZ = ((preMeshManage.getModelSize().z) / (longLength / 10)) * DEFAULTSEALPLATEWIDTH;
                lastMoveZ = ((this === null || this === void 0 ? void 0 : this.templateJson.bottom.type) === 'H' || (this === null || this === void 0 ? void 0 : this.templateJson.bottom.type) === 'I') ? lastMoveZ + sealPlateMesh.getModelSize().z : lastMoveZ;
                // eslint-disable-next-line no-case-declarations
                const moveSealZ = checkFrameIsCornerFrames(frameData) ? sealPlateMesh.getModelSize().z * 0.5
                    : -sealPlateMesh.getModelSize().z * 0.5;
                sealPlateMesh.setModelPosition({
                    x: preMeshManage.mesh.position.x - preMeshManage.getModelSize().x * 0.5
                        - sealPlateMesh.getModelSize().x * 0.5,
                    y: SKIRTINGBOARDCONFIG.HEIGHT,
                    z: lastMoveZ + moveSealZ,
                });
                return sealPlateMesh;
                break;
            default:
                return null;
                break;
        }
    }
    /**
       * 获取水槽挖孔的相关定位及尺寸
       * @param sinkCabinetId 水槽所在柜子的ID
       * @param sinkId 水槽id
       * @param topPanelPositionY 台面的高度 需要确定洞在Y轴上面的方向
       * @returns 洞的定位跟尺寸
       */
    // eslint-disable-next-line max-len
    getSinkHolePosition(sinkCabinetId, sinkId, topPanelPositionY, cornerCabinetDirection, sinkInfo) {
        var _a;
        const sinkMesh = this.scene.getMeshByName(sinkId); // 定义水槽模型
        const sinkFrameMesh = this.scene.getMeshByName(sinkCabinetId); // 定义水槽所在柜子的整体模型
        let holePosition;
        let holeSize;
        if (RenderVersion.checkOldRenderVersion(((_a = this === null || this === void 0 ? void 0 : this.templateJson) === null || _a === void 0 ? void 0 : _a.version) || '2.1', VERSION_2_2)) {
            holePosition = getOldXSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection).holePosition;
            holeSize = getOldXSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection).holeSize;
        }
        else {
            holePosition = getNewSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection, sinkInfo, 'x').holePosition;
            holeSize = getNewSinkHoleInfo(sinkFrameMesh, sinkMesh, topPanelPositionY, cornerCabinetDirection, sinkInfo, 'x').holeSize;
        }
        return { holePosition, holeSize };
    }
    // 获取该方向边长,画墙需要一个最小长度，保证房间足够大
    getSideLength(minimum = 0) {
        var _a;
        // debugger;
        const { lastFrame, location } = this.getLastFrame();
        const meshManage = new MeshManage(this.scene.getMeshByName((_a = lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.componentBasic) === null || _a === void 0 ? void 0 : _a.id));
        let length;
        if (lastFrame) {
            length = meshManage.getModelSize().x / 2 + Math.abs(meshManage.mesh.position.x) + this.getRLength();
        }
        else {
            length = this.templateJson[location][this.lengthType].length * 0.01;
        }
        if ((lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.categoryId) === FRAMECATEGORY.CATEGORY_39) {
            if ((lastFrame === null || lastFrame === void 0 ? void 0 : lastFrame.width) === 100) {
                length += DOUBLE_DOOR_REFIRGERATOR_DISTANCE;
            }
            else {
                length += SINGLE_DOOR_REFIRGERATOR_DISTANCE;
            }
        }
        return Math.max(length, minimum);
    }
    createWall(width) {
        const wallNode = new Wall(this.scene);
        const sideLength = width !== null && width !== void 0 ? width : this.getSideLength();
        const fromPoint = { x: 0, y: 0, z: -GAP_BETWEEN_WALL_AND_CABINET };
        const toPoint = { x: -sideLength, y: 0, z: -GAP_BETWEEN_WALL_AND_CABINET };
        const wallSegmentNode = {
            toPoint,
            fromPoint,
            wallHeight: TOPFRAME_GROUND(this.templateJson),
            name: 'lengthX',
        };
        wallNode.createWall(wallSegmentNode, { x: 0, y: 0, z: 0 }, { x: 0, y: 0, z: 0 });
        this.wallNode = wallNode;
    }
    createWindow(frame, window) {
        var _a, _b;
        if (!frame || !window.componentBasic.modelUrl) {
            return;
        }
        const windowNode = new WindowNode(this.scene, this.templateJson);
        const { width: windowWidth, height: windowHeight } = window.componentBasic;
        const frameMeshManage = new MeshManage(this.scene.getMeshByName(frame.componentBasic.id));
        const { position } = frameMeshManage.mesh;
        let windowPosition = position;
        // 判断柜体是不是带水槽的转角柜  如果是带水槽的转角柜位置根据水槽的中心点来判断
        if (frame.categoryId === FRAMECATEGORY.CATEGORY_27) {
            const { cornerCabinetDirection } = getFramePositionInfo(this.templateJson, 'sink');
            const sinkMesh = new MeshManage(this.scene.getMeshByName(((_b = (_a = frame.sink) === null || _a === void 0 ? void 0 : _a.componentBasic) === null || _b === void 0 ? void 0 : _b.id) || ''));
            windowPosition = getCornerCabinetFrameXZ(position, frameMeshManage.getModelSize(), sinkMesh.getModelSize(), cornerCabinetDirection, `length${frame.longEdge}`, 'ventilator');
        }
        const windowSegmentNode = {
            width: windowWidth / 1000,
            height: windowHeight / 1000,
            name: 'lengthXWindow',
            // eslint-disable-next-line max-len
            position: { x: windowPosition.x, y: TOPFRAME_GROUND(this.templateJson) - windowHeight / 1000 / 2, z: 0.01 - GAP_BETWEEN_WALL_AND_CABINET },
            textureImage: window.componentBasic.modelUrl,
        };
        windowNode.createWindow(windowSegmentNode, { x: 0, y: -Math.PI, z: 0 });
        this.windowNode = windowNode;
    }
    getFramesCalloutLine(position, title) {
        const topToGround = this.getCalloutLineTopToGround(position);
        const { length, lengthValue } = this.getLengthByAddAllFrames(position);
        const { startHeight, endHeight } = this.getCalloutLineHeightLength();
        const calloutLineDepthLength = this.getCalloutLineDepthLength();
        /* -----------长度标线----------- */
        const startPoint = { x: 0, y: topToGround + CALLOUTMARGIN, z: 0 };
        const endPoint = { x: -length, y: topToGround + CALLOUTMARGIN, z: 0 };
        const lengthLine = { startPoint, endPoint };
        /* -----------长度标线----------- */
        /* -----------高度标线1----------- */
        // 长度标线起点的高度标线起点
        const startHeightStartPoint = {
            x: startPoint.x + CALLOUTMARGIN,
            y: this.getCalloutLineHeightHeight(),
            z: startPoint.z,
        };
        // 长度标线起点的高度标线终点
        const startHeightEndPoint = {
            x: startHeightStartPoint.x,
            y: startHeightStartPoint.y + startHeight,
            z: startHeightStartPoint.z,
        };
        // 长度标线起点的高度标线
        const startHeightLine = {
            startPoint: startHeightStartPoint,
            endPoint: startHeightEndPoint,
        };
        /* -----------高度标线1----------- */
        /* -----------高度标线2----------- */
        // 长度标线终点的高度标线起点
        const endHeightStartPoint = {
            x: endPoint.x - CALLOUTMARGIN,
            y: this.getCalloutLineHeightHeight(),
            z: endPoint.z,
        };
        // 长度标线终点的高度标线终点
        const endHeightEndPoint = {
            x: endHeightStartPoint.x,
            y: endHeightStartPoint.y + endHeight,
            z: endHeightStartPoint.z,
        };
        // 长度标线终点的高度标线
        const endHeightLine = {
            startPoint: endHeightStartPoint,
            endPoint: endHeightEndPoint,
        };
        /* -----------高度标线2----------- */
        /* -----------深度标线1----------- */
        // 长度标线起点的深度标线起点（长度标线起点的高度标线起点）
        const startDepthStartPoint = startHeightStartPoint;
        // 长度标线终点的深度标线起点
        const startDepthEndPoint = {
            x: startDepthStartPoint.x,
            y: startDepthStartPoint.y,
            z: startDepthStartPoint.z + calloutLineDepthLength,
        };
        // 长度标线终点的深度标线
        const startDepthLine = {
            startPoint: startDepthStartPoint,
            endPoint: startDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        /* -----------深度标线2----------- */
        // 长度标线终点的深度标线起点（长度标线终点的高度标线起点）
        const endDepthStartPoint = endHeightStartPoint;
        // 长度标线终点的深度标线起点
        const endDepthEndPoint = {
            x: endDepthStartPoint.x,
            y: endDepthStartPoint.y,
            z: endDepthStartPoint.z + calloutLineDepthLength,
        };
        // 长度标线终点的深度标线
        const endDepthLine = {
            startPoint: endDepthStartPoint,
            endPoint: endDepthEndPoint,
        };
        /* -----------深度标线2----------- */
        const calloutLinesArr = [];
        calloutLinesArr.push({
            type: 'length', line: lengthLine, value: lengthValue, title: title || 'L1',
        });
        calloutLinesArr.push({
            type: 'startHeight', line: startHeightLine, value: startHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'endHeight', line: endHeightLine, value: endHeight, isHeight: true,
        });
        calloutLinesArr.push({
            type: 'startDepth', line: startDepthLine, value: calloutLineDepthLength,
        });
        calloutLinesArr.push({
            type: 'endDepth', line: endDepthLine, value: calloutLineDepthLength,
        });
        return calloutLinesArr;
    }
}
export default LengthX;
